import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Modal({ isOpen, onClose, title, children }) {
  useEffect(() => {
    if (!isOpen) return;
    const h = e => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", h);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", h); document.body.style.overflow = ""; };
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}
          className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-4"
          role="dialog" aria-modal="true" aria-label={title}>
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose}/>
          <motion.div
            initial={{opacity:0,y:60,scale:0.97}} animate={{opacity:1,y:0,scale:1}}
            exit={{opacity:0,y:60,scale:0.97}} transition={{type:"spring",duration:0.45,bounce:0.25}}
            className="relative z-10 bg-white rounded-3xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col shadow-2xl">
            {/* Header */}
            <div className="flex items-center justify-between px-7 py-5 border-b border-gray-100">
              <h2 style={{fontFamily:"'Syne',sans-serif",fontWeight:700}} className="text-gray-900 text-xl">{title}</h2>
              <button onClick={onClose}
                className="w-8 h-8 flex items-center justify-center rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-500 transition-colors text-sm"
                aria-label="Close">✕</button>
            </div>
            {/* Body */}
            <div className="px-7 py-6 overflow-y-auto">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
